<template>
	<div>
		<pre>{{ error }}</pre>

		<div class="wrapper">
			<div class="row">
				<div class="col">
					<img
						src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDcuMS1jMDAwIDc5LmIwZjhiZTkwLCAyMDIxLzEyLzE1LTIxOjI1OjE1ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjMuMiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QzA3M0Q3NjFBOUYxMTFFQzlGRjVCMUYwQjY1NEE2OTkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QzA3M0Q3NjJBOUYxMTFFQzlGRjVCMUYwQjY1NEE2OTkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDMDczRDc1RkE5RjExMUVDOUZGNUIxRjBCNjU0QTY5OSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDMDczRDc2MEE5RjExMUVDOUZGNUIxRjBCNjU0QTY5OSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpK9ZEQAAA7FSURBVHja7F15UBRXHh4QBgZGBbkcEAREEBDkUBBFCSJJKgY1ksTdNRITbzGairIaXWUtj/yhiRRK7W6M0azGI5bHgquBKGhE8UARhlF0hOEGuRk5B9D9Xopxm54ZZKC7ByvpqldjD9P9fu/r3/W9/r2n3osXL3h/HP0/9P+AYGCHwWAQoquri1dfX88vLi4WPX361Ly8vFzU2toqVCgUfFiInqGhYadAIGgaNWpUqaWl5TMLC4s6Ozu7eiMjo98ngE1NTTyxWOyUkZEx8c6dOwH4tw+As6upqbHHn03R9DRcSvxNm4mJSf3IkSOLPDw8sn18fLKmTp16OyAgQDJixIgOzgdDfCAXrb29nXfx4kXvJUuWbHZ0dLyBrp91A8JE6wCg9yMiIuIPHz48o6qqypCrcbHeQVlZmen27dsXQFtSMFAFg6BpbADz3vLlyzdkZWXZsj0+PbaiMPyYaUJCwoIDBw5EV1dXe/fy045hw4aVOjs754lEogoXF5c8+Dg5vms0NjZuhXz68IVGzc3NpjB9YX5+voNMJnMpLCx0g8nb4XqhphvDd1bMnj37xy+//HKfv79/8WthwsS/bdu2baGVlVW2Jg0BMOUhISHHYmNjl/zyyy/eAFuobT94KEY3b950/uabb94HSPsA+gNN/RkYGFRERUVtlUqlZoPahBMTE308PT3PaxhIGxx+0u7du+fn5eVZMj0QBCHB0aNHQ999990EAFapTgYEmVz0/x6J+oMKQKJ1n3322WoIKVcjeB0Gtf/ChQs+nZ2dnDj2e/fu2RIfaGZm9kgdkOHh4f9gShsHfAOJRGIVGBj4oxpBO6dPn3748uXL47iKiPQGkMw//vjjrfr6+tV0+WxsbDLPnj3rp1MAU1NT3eDr7qmJgncPHjwYpivg6O3KlStjg4KCjqmzDvjQOToB8NChQ9P5fH4pTaCuuXPn7i4qKhIOFvCUjbiPzZs3fzJkyJAqmswKuJ9oTgFEajIDHddSBSGC4WnOHWzA0VtKSoqHra3tLbo2Ll68OOb58+fsA4hMf5qenl4tLbqJwTLGD3bwlO3JkyfDQf2O00FcsWLFWlYBTEtLc0VyWk53xrdu3Rr9uoCnbHV1dYbIRQ/QQHy+Y8eOD1kB8OHDh5ZIVrNo4N1ByiBiY4AtLS2EBg4rLi4egWZOUiWm+2hsbNQPDQ39lgZiI/LJKYwCCBqlByp0gtqRubm5mGnNKykpEe7cuXMhBnV0zJgx14VCYbFAIKhEK3dycspYunTpptzcXEaT8Pr6egOkYT0iNGjko+zsbBFjAEZHR6+hdoC8qiY5OdmTyYGQfNHa2jrrVRMFQ4cOlZ46dSqIyb6h4cJRo0bdoPYzceLEE21tbQMHMCkpaQJt6qnr66+/nsOwKRlAw1L7OtsCqlZy9+5deyZlAK92hKaXUPvZsmVL1IAAhN8ZMnbs2BTqTSMjI79i2hddvXrVgzhwbaaswDD+zrQce/bsmUsURNkHAmYZHtSofgMYGxu7kMYwMkHaTZgWPD4+fp62c35IQ5KYloPkgW+//fY+aj+I1N/1C8CKigpTkHHqFJHi+++/D2Uj4sbExKwfDACS9uDBA2tTU1MZdRbpzJkz/pp+r/GtXFxc3IKGhgZ35Tm45E+LFi1KY2NOEqai9bsM+MFONmRxd3evWrt27XbKV0awxFgyBdbnCVVonwnSFAmFptURQs5WUgvf8ydtNfCtt976gS15SFBzcHDIoPTXfv78ed8+ayC47nvIjzyU57Nmzfo3fIGUrRdbbm5uBdpeIxKJitiSB3lg57Jly/ZRvuLjIa9W+/qDjmhra6seIu9lCvqtyPm82KRVt2/fdga/btJGA7du3bqSTZmqqqqMwLxyKVZYiyRe9EoNBN/1kkql05Tn48ePTwsLCxOz+WoVrKMULqNcy2sesymTlZVV+8KFCw9QXv6POHHixKxXlnacPn16NvHrynPkW4eAPqvvpocPH64YPXq0Ni7iBX5fzfY7848++ugcLEOuPD958uSfFQqFZhMG59W3t7e/qVRbPp9fCW0cwcXsyPz58/f01XxJUMvJyRnJtkwk8np7e1NfkjVmZWXZazRhsVg8GoTeS3mOXCvVxcWljosKCT8/v2wtzKuUCw0E5+dFREQkUuML4kGwRhNOT0+fhA8T5Tl832WuSkw8PDwedNO5vkTtXETKLi7kmjlzZnp3RcVvB2hniEYAEQ0DKKeKadOm3eIKwHHjxhXCZdT05bc+Pj53uZJrwoQJT6DxLwOWRCLxJbM0KgASHog/+ijPhw4dWubp6SnjSlCYZC3875O+BBBfX18xV3IhO1CAnTyglKyMkclkNioA1tXV8cFA7ChpQh6Qb+ZKUNA5YsY5ffhpC1KrR1xWsAHAlw+ss7PTPC8vz1EFwNLSUluAaK88t7OzK2c7faEf0Kx7r/qNtbV1IR5uGZdygVjkU90eAq2zCoBQTTN8GCvPnZ2dOX3K3b4tt3s+TuPh6uoqMTMz6+RSLvjnHq6lpqZGqAIgzNcWH0MoqYKcawCRcz1CIKl9RbSWcC0XIn4rsV7leWFhoaoGggObUi9CEGnkWlAHB4c6aL7kFVExm2u5jI2NW0gdo/K8qanJTAVAUtBNu6iVa0FJIPH39+8tdWr38vJ6yLVcsAoFkuqXrqW9vZ2vAiCphqdehLRGJ0sggoODM3rhzKXwgSVcy4Rg2gVOTE3y9VQAJEsJqBeRslpdAIhILIGwLRpyRamNjQ3nltHR0WFIVShgpVABUCAQ9Mj5WlpaTHUBINEwCwsLtZOlMN8cXchE4gMs1IiCVZsKgMj7SqkpBCno1oWwJPMHA1KbD+J7iS5kksvlAuoUHx5wmQqAMA05NVSTaniejo7AwMDbar5+ziWFox50LOBKKlQARHJai8j7cuqqoKDAlfBjXRyTJk3KpH9nampaCg2U6kIesDQqgM+dnJwKVAAEkW8QiUSFynMQ5rENDQ18XQjs5+f3EA+zkpZA34ObadKFPDk5OZ5Ul+ji4qJqwsh1epD5+vp6O2ihrS4ExsOsB1hU/smbPn16Kpng5PpAMNWXSCTeFIZW6OjoqApgNxfNouSBwvT09Im6AJAk1O+8885ZROTr4KHpbm5u6fPmzUvWhSyPHz+2LSkp8aTw4pweXJw6v//zzz+TSqyX69kiIiL266qClPhf8gIHOdhvTVdyxMXFRfIo72M2bNiwSmNtDHyeIVQ0R/ljIJ1XVVVl/LqV7zLZQkNDD1EA7CArTnstLiLrzigXPD9y5Ejo7xU8xAAzBLMy3v+r07KgZAa9vliPjIw8Q+V8x44d+5D3Oz2OHz8+q62t7WUgDQ8PTwIf70F5VZa71tTU8N3d3TPx6dXt0KszMzO9cVRyKXx2drYdfHIYsgEbCF0dFhZ2NSAggLN3NGSBOKjjZalUOqP7q7aUlJSJALEnG1KnukuXLt1IdZyLFi36G1dmQyrnly9fHqNmRVH9ggULtuHBGnAhx7lz5yZ1M7Pf+odSXSRBrU8FlqRCHXnhU+XFYAHFRUVFwzlYu8GfMmXKD7xeqhLI2g6iHWzKQYCiL8RJSEiYpVWFKoLJXuoNoqKiWNdC0gevD6Udu3fvfp9NOUglLo9Ssw3ue00ulxtoBWBGRsZomNHLZaJgAXW//vqrC5sRD1pf3hcA4Y8vQEv02JADPteQAEbtLz4+fna/iszhc2KpN/L39/+JraT2xo0b7lSf01tDfppfW1trxIYcK1eu/Jzal5OTU1pzc/OQfgEok8nMEAF77EWwcePGT3QNIGQqQDBhPMFH1PfU09NroPTVfvLkycABLbTZv3//LB5l7QRMufbSpUuMr0LHwzKnJq29NXDktNbWVn2GK1KNYbrp1H7Ax/cOeKUS4aTIfRJ4tBWaINnmTIM4Z86cPtUIxsTErGSadyPP/Ce1DwsLi/vwy8MYWSuXn59vRm5I7cDX1/c0/JAhw4HEHFpwtTfwyN/JKgIm+0XeuY7Wj/zUqVMBjC53TUxMJDM1dbSc7DuS+DI5mLy8PCvkYCepbkPZ/Pz8Tufm5tow2d8XX3yxgkdbZrZu3bplrCy4Jhs00B39G2+88S1ZMsp0Inv27NnJ0dHRmz744IP90JCt0Ijgvqye7Ad4PcYTGRm5S5vtWbTudPXq1avomhEUFHS0rKzM5HWZZSEAIV2hm+2LwMDAI9paVL8EIBs00Dsn+dL169edBjt48J+CN998M4EuP1lQXllZqXVu2e+otWrVqjV03yEQCAr37Nnz3mAF78KFC17Ozs5X1Glef8Ab8MY7O3funA8BGukCRURExInFYuvBAhyZwYHr+ZweBEmDj90JH97vQDhg4Y4cORIMZiChCyYUCp9s2rRpcXV1taGugCPrPA4ePDjDxcUlTU1K1Lh+/frl/dkrhvHNx7KyskSTJ08+qiFvS9+xY8dfYCKcvVsBS+GdOXMmMDg4WK1MhAi8iqJxvv0dmaOLjY2N4vP5JRqEzkbasCYjI8OJye3naBvqmMOtkN0ykzXw6jbCdkAMGJvbZHwQd+7csZ85c+a/yBt8DWyiEQlx4pYtW5alpqZ6gs3w+9tXc3MzLzMz02Hv3r2R6POQiYlJsSYG4+bmlnL8+PEgpsfL2hagSUlJ/rt27frrzZs3yeJFYw0/U0AzH7u6uj4gVRFjxowp8PT0fAL/2YqI3qKsDEXeZkjK7Z49e2YC7bEntSrZ2dnjwVrGy2Qysq55uCY5cM+ra9as2fvpp5/+B/dlfqBsO3EA6RceHv6tmnccve7KS6oqAJ4c1zV2ryXWZgPbFm9v7/+SaXi5XK7P5hg5i4j379+33bhx44ru3XwbeMzv3tspEokyyXYoycnJ49W9AHqtdvHVdJCBIUd0uHTp0tRr165Nk0gk/jBJZ5ippZa3aoL5y+DbxKCS10NCQm4gExCbm5t3cTkezgGkH2SCoKCgYKRUKiXbGzs1NDQMw7lzU1PTcER2UlZLtoLvICXIlpaWFQ4ODhWkPg+MogyfZQCsU5fy6xzA1/34439zGODxPwEGAFHfdQMIOl0bAAAAAElFTkSuQmCC"
						alt=""
					/>
					<p>
						The website you are trying to visit is currently unavailable due to maintenance of the server.
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	error: { type: Object, default: () => {} },
});
</script>

<style scoped>
* {
	box-sizing: border-box;
}

a {
	color: #11008b;
	text-decoration: none;
}

a:hover {
	color: #0c9;
}

a,
button {
	transition: all 0.3s ease-in-out;
}

html {
	height: 100%;
}

.wrapper {
	background: #11008b;
	font-family: Poppins, sans-serif;
	line-height: 2em;
	color: #11004e;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 100vh;
	overflow: hidden;
	margin: 0;
}

.row {
	width: 96%;
	max-width: 920px;
	margin: 0 auto;
	background-color: #fff;
	padding: 60px;
	border-radius: 5px;
}

.col {
	display: flex;
	flex-wrap: nowrap;
	justify-content: space-between;
	align-items: center;
}

.col p {
	margin: 0;
}

.button {
	padding: 6px 15px;
	display: inline-block;
	float: none;
	text-decoration: none;
	color: #fff;
	background: #0c9;
	border-radius: 5px;
	margin-top: 5px;
}

.button:hover {
	background: #04e6ae;
	color: #fff;
}

img {
	margin: 0 30px 0 0;
	width: 40px;
	height: 40px;
}

@media (max-width: 1000px) {
	.wrapper {
		padding: 50px;
		text-align: center;
		max-width: 780px;
	}

	.col p {
		margin: 10px;
	}
}

@media (max-width: 700px) {
	img {
		margin: 10px auto;
	}

	.wrapper {
		padding: 30px 20px;
	}

	.col {
		flex-wrap: wrap;
	}
}
</style>
